module.exports = __webpack_public_path__ + "static/media/down.db29e171.jpg";